import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-800 text-background-100">
      <div className="w-full px-4 md:px-6 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-3 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-chat-smile-2-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">哈哈漫画</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              韩国漫画免费在线观看平台，提供高清韩漫全集下拉式阅读。海量漫画资源，每日更新，随时随地畅享阅读乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-200 mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: '恋爱漫画', href: '/category/lianai' },
                { label: '奇幻漫画', href: '/category/qihuan' },
                { label: '动作漫画', href: '/category/dongzuo' },
                { label: '关于我们', href: '/about' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-200 mb-4">
              帮助中心
            </h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: '常见问题', href: '/about' },
                { label: '阅读指南', href: '/about' },
                { label: '联系我们', href: '/about' },
                { label: '用户协议', href: '/about' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-200 mb-4">
              关注我们
            </h4>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-bilibili-line', label: 'B站' },
              ].map((social) => (
                <a
                  key={social.label}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-600 transition-colors cursor-pointer"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-sm text-background-200`}></i>
                </a>
              ))}
            </div>
            <p className="mt-4 text-xs text-background-400">
              客服邮箱：hello@heniukeji.com
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-400">
              &copy; {currentYear} 哈哈漫画网 hahamanhua.com 版权所有
            </p>
            <div className="flex items-center gap-4 text-xs text-background-400">
              <a href="#" className="hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">服务条款</a>
              <a href="#" className="hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">网站地图</a>
            </div>
          </div>
        </div>

        <div className="mt-10 overflow-hidden">
          <div className="text-[5rem] md:text-[8rem] lg:text-[11rem] font-heading font-black text-background-700/25 leading-none tracking-tighter select-none whitespace-nowrap text-center">
            哈哈漫画
          </div>
        </div>
      </div>
    </footer>
  );
}